<template>
  <div>
    <h1>Comprar Llaves</h1>

    <form
      action="https://sis-t.redsys.es:25443/sis/realizarPago"
      method="post"
      accept-charset="UTF-8"
      @submit="setParamsTopay()"
    >
      <div>
        <label for="quantity">Cantidad</label>
        <input type="number" v-model="cantidad" name="quantity" placeholder="cantidad">
        <div>
          <span>Precio por llave {{precio}}€</span>
        </div>
        <div>
          <span v-if="cantidad > 0">{{cantidad}} x {{calcular}}€</span>
        </div>
      </div>
      <div>
        <input type="hidden" name="Ds_SignatureVersion" value="HMAC_SHA256_V1">
        <input
          v-model="pasarelaData.merchantParameters"
          id="Ds_MerchantParameters"
          type="hidden"
          name="Ds_MerchantParameters"
        >
        <input type="hidden" v-model="pasarelaData.signature" name="Ds_Signature">
      </div>

      <!-- <button v-if="!isChecked" @click="checkUser()" type="button" class="btn btn-primary">Continue</button> -->
      <div>
        <button :disabled="cantidad<1" type="submit" class="btn btn-primary">Buy keys</button>
      </div>
    </form>
  </div>
</template>

<script>
import i18n from '@/plugins/i18n';

export default {
  data() {
    return {
      prueba: "hola",
      cantidad: 0,
      pasarelaData: {},
      precio: 2,
      
      datosFake: {
        description: "",
        total: 0 ,
        titular: "Lightbee,S.L",
        orderId: "0000000003",
        paymentId: "0000000003"
      }
    };
  },
  methods: {
    setParamsTopay(facturacion) {
            
      this.axios
        .post("https://lightkey.es:3000/lightkey/api/owner/payment", facturacion)
        .then(response => {
          this.pasarelaData = response.data;
        })
        .catch(error => {
          console.log("Ha ocurrido un error.");
        });
    },
    setLanguage(){
      if(localStorage.getItem('language')){
        console.log(localStorage.getItem('language'));
        i18n.locale = localStorage.getItem('language'); 
      }else{
        console.log("No hay lenguaje");
      }
    }
  },
  computed: {
    calcular() {
      this.datosFake.total = this.precio * this.cantidad;
      //Pedir que te haga el ajuste
      this.setParamsTopay(this.datosFake);
      return this.datosFake.total;
    },
    pedirDatosFacturacion () {
      //TODO: Añadir una collecion dentro de la base de datos que puedas guardar los datos de facturacion

      //Mientras fake, suma 1
    }
  },
  created() {
    this.setLanguage();
  },
  watch: {
    cantidad() {
      if (this.cantidad < 0) {
        console.log("No puede ser menor pisha");
        this.cantidad = 0;
      }
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/dashboard/children/Buykeys.vue